<template>
  <b-card>
    <b-tabs>
      <b-tab :title="$t('Mentoring')" active>
        <b-card-title>
          {{ $t('Rejected mentorship requests') }}
        </b-card-title>
        <div v-if="rejectedMentrorshipRequestsForMentoring.length">
          <rejected-mentorship-requests-table
            :mentorship-requests="rejectedMentrorshipRequestsForMentoring"
            @show-mentee-details="showMenteeDetails"
          />
        </div>
        <div v-else class="no-data-card-body">
          <feather-icon
            icon="ThumbsUpIcon"
            size="25"
          />
          <b-card-text>
            {{ $t('You do not have any rejected request!') }}
          </b-card-text>
        </div>
      </b-tab>
      <b-tab :title="$t('Coaching')" v-if="mentor.is_coach">
        <b-card-title>
          {{ $t('Rejected mentorship requests') }}
        </b-card-title>
        <div v-if="rejectedMentrorshipRequestsForCoaching.length">
          <rejected-mentorship-requests-table
            :mentorship-requests="rejectedMentrorshipRequestsForCoaching"
            @show-mentee-details="showMenteeDetails"
          />
        </div>
        <div v-else class="no-data-card-body">
          <feather-icon
            icon="ThumbsUpIcon"
            size="25"
          />
          <b-card-text>
            {{ $t('You do not have any rejected request!') }}
          </b-card-text>
        </div>
      </b-tab>
    </b-tabs>
    <mentee-details-modal ref="mentee-details-modal" />
  </b-card>
</template>

<script>
import {
  BCard,
  BCardText,
  BCardTitle,
  BTab,
  BTabs
} from 'bootstrap-vue'
import MenteeDetailsModal from '@mentoring-platform/views/components/blocks/MentorMentorships/MenteeDetailsModal.vue'
import RejectedMentorshipRequestsTable from '@mentoring-platform/views/components/blocks/MentorAdmin/RejectedMentorshipRequestsTable.vue'
import { useMentorMentorships } from '@mentoring-platform/composables'

export default {
  components: {
    BCard,
    BCardText,
    BCardTitle,
    BTab,
    BTabs,
    MenteeDetailsModal,
    RejectedMentorshipRequestsTable
  },
  props: {
    mentor: {
      type: Object,
      required: true
    }
  },
  data() {
    return {

    }
  },
  computed: {
    rejectedMentrorshipRequestsForMentoring() {
      return this.rejectedMentorshipRequests.filter(request => request.is_coaching == false)
    },
    rejectedMentrorshipRequestsForCoaching() {
      return this.rejectedMentorshipRequests.filter(request => request.is_coaching == true)
    }
  },
  beforeMount() {
    this.$bus.$on('mentorship-request-approved', this.refreshList)
    this.$bus.$on('mentorship-request-rejected', this.refreshList)
  },
  beforeDestroy() {
    this.$bus.$off('mentorship-request-approved', this.refreshList)
    this.$bus.$off('mentorship-request-rejected', this.refreshList)
  },
  methods: {
    refreshList() {
      this.getMentorshipRequests(this.mentor)
    },
    showMenteeDetails(request) {
      this.$refs["mentee-details-modal"].show(request);
    }
  },
  setup(props) {
    const { getMentorshipRequests, rejectedMentorshipRequests } = useMentorMentorships()
    getMentorshipRequests(props.mentor)

    return {
      rejectedMentorshipRequests,
      getMentorshipRequests
    }
  }
}
</script>

<style scoped>

</style>
